import { render, staticRenderFns } from "./RbFilters.vue?vue&type=template&id=4160ca79&"
import script from "./RbFilters.vue?vue&type=script&lang=js&"
export * from "./RbFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports